<template>
    <div class="mux-player-container">
        <mux-player
            ref="player"
            :playback-id="playbackId"
            :poster="poster"
            :title="title"
            :accent-color="accentColor"
            :metadata="playerMetadata"
            stream-type="on-demand"
            @ended="onEnded"
            @timeupdate="onTimeUpdate"
            @seeking="onSeek"
            @loadedmetadata="onLoadedMetadata"
        />
    </div>
</template>

<script>
export default {
    name: 'Mux',
    props: {
        src: { type: String, default: '' },
        poster: { type: String, default: '' },
        controls: { type: Boolean, default: true },
        metadata: { type: Object, required: true },
        preventSeek: { type: [String, Boolean], default: false, options: [true, false, 'forward'] },
        title: { type: String, default: '' }
    },
    emits: ['played', 'duration'],
    data() {
        return {
            accentColor: 'var(--button-colour, --primary)',
            lastValidTime: 0
        };
    },
    computed: {
        playbackId() {
            return this.metadata?.metadata?.playbackId;
        },
        playerMetadata() {
            return {
                'video_id': this.playbackId,
                'video_title': this.title,
                'player_name': 'Mux Player',
                'player_version': 'latest'
            };
        }
    },
    mounted() {
        import('@mux/mux-player');
    },
    methods: {
        pause() {
            if (this.$refs.player) this.$refs.player.pause();
        },
        forward(to) {
            if (this.$refs.player) {
                const newTime = this.$refs.player.currentTime + to;
                if (!this.preventSeek || newTime <= this.$refs.player.currentTime) {
                    this.$refs.player.currentTime = newTime;
                }
            }
        },
        onLoadedMetadata(e) {
            const videoEl = e.target.media.nativeEl;
            this.$emit('duration', videoEl.duration);
        },
        onEnded() {
            this.$timeout(() => {
                if (this.$refs.player) this.$emit('played', this.$refs.player.media.nativeEl.played);
            }, 1000);
        },
        onTimeUpdate() {
            this.$emit('played', this.$refs.player.media.nativeEl.played);
            if (!this.$refs.player || !this.$refs.player.seeking) {
                this.lastValidTime = this.$refs.player.currentTime;
            }
        },
        onSeek(e) {
            if (!this.preventSeek) return;

            const currentTime = this.lastValidTime;
            const targetTime = this.$refs.player.currentTime;

            if (this.preventSeek === true || (targetTime > currentTime && this.preventSeek === 'forward')) {
                e.preventDefault();
                this.$nextTick(() => {
                    this.$refs.player.currentTime = currentTime;
                });
            }
        }
    }
};
</script>

<style lang="less">
.mux-player-container {
    width: 100%;
    height: 100%;
    background: var(--coal);

    mux-player {
        width: 100%;
        height: 100%;
        --media-object-fit: contain;
        --media-object-position: center;
        --controls-backdrop-color: rgba(0, 0, 0, 0.7);
        
        // Hide seek buttons
        --seek-backward-button: none;
        --seek-forward-button: none;
    }
}
</style>
